import { fromJS } from 'immutable';

import * as globalActions from '../actions/global';
import { fetchingState } from '@constants';
import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';

const initialState = {
  selectedAppeal: null,
  preference: {},
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case globalActions.SELECT_APPEAL_RECORD:
      return state.merge({
        selectedAppeal: action.data,
      });
    case globalActions.RESET_ACTIVE_RECORDS:
      return state.merge({
        selectedAppeal: null,
      });
    case globalActions.PREFERENCE_FETCH[START]:
      return state.setIn(['preference', 'state'], fetchingState.FETCHING);
    case globalActions.PREFERENCE_FETCH[SUCCESS]:
      let newState = state.setIn(['preference', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );
    case globalActions.PREFERENCE_FETCH[ERROR]:
      return state.setIn(['preference', 'state'], fetchingState.ERROR);

    case globalActions.PREFERENCE_PERSIST[SUCCESS]:
      newState = state.setIn(['preference', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['preference', 'data'],
        fromJS(
          action.data.results.length > 0
            ? action.data.results[0].preference
            : {},
        ),
      );

    default:
      return state;
  }
};
